import { TableGroupModel } from "./table-group.model";

export class CreateOrEditCapacityModel {
  public id: string;
  public name: string = 'Default capacity';
  public description: string;
  public startDate: string;
  public endDate: string;
  public startTime: string;
  public endTime: string;
  public venueId: string;
  public isDefault: boolean = true;
  public capacityGroups: Array<TableGroupModel>;
}
